import { Link } from 'react-router-dom';
import { categories } from '@/mocks/novels';

export default function CategoryNav() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-2">探索不同类型的都市情感故事</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-6 bg-background-100 rounded-lg border border-background-200/70 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 mt-1 text-center">
                {cat.description.slice(0, 16)}...
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}